module.exports = __webpack_public_path__ + "static/media/a.e1a0eef6.svg";